// Google Analytics utility functions

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, parameters);
  }
};

export const trackPhoneClick = (phoneNumber, location = 'unknown') => {
  trackEvent('phone_call', {
    phone_number: phoneNumber,
    location: location
  });
};

export const trackWhatsAppClick = (phoneNumber, location = 'unknown') => {
  trackEvent('whatsapp_click', {
    phone_number: phoneNumber,
    location: location
  });
};

export const trackDownload = (fileName, fileType = 'unknown') => {
  trackEvent('file_download', {
    file_name: fileName,
    file_type: fileType
  });
};

export const trackPageView = (pageName) => {
  trackEvent('page_view', {
    page_title: pageName
  });
};

export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    ...formData
  });
};